import { call, put } from "redux-saga/effects";
import WebhookActions from "./webhook.reducer";
import * as api from "../../../Service/api";

export function* getWebhook(action) {
    const { businessId } = action;
    const response = yield call(api.getWebhook, businessId);

    if (response.ok) {
        yield put(WebhookActions.webhookSuccess(response.data));
    } else if (response.status === 404) {
        yield put(WebhookActions.webhookSuccess(null));
    } else {
        yield put(WebhookActions.webhookFailure(response.data));
    }
}

export function* createWebhook(action) {
    const { businessId, url, interests, authHeaderName, authHeaderValue } = action;
    const response = yield call(api.createWebhook, businessId, url, interests, authHeaderName, authHeaderValue);

    if (response.ok) {
        yield put(WebhookActions.createWebhookSuccess(response.data));
    } else {
        yield put(WebhookActions.createWebhookFailure(response.data));
    }
}

export function* updateWebhook(action) {
    const { webhookId, businessId, url, interests, authHeaderName, authHeaderValue } = action;
    const response = yield call(api.updateWebhook, webhookId, businessId, url, interests, authHeaderName, authHeaderValue);

    if (response.ok) {
        yield put(WebhookActions.updateWebhookSuccess(response.data));
    } else {
        yield put(WebhookActions.updateWebhookFailure(response.data));
    }
}

export function* toggleWebhook(action) {
    const { webhookId } = action;
    const response = yield call(api.toggleWebhook, webhookId);

    if (response.ok) {
        yield put(WebhookActions.toggleWebhookSuccess(response.data));
    } else {
        yield put(WebhookActions.toggleWebhookFailure(response.data));
    }
}
